import { wpLinkize } from 'mk/bazaar/common/filters';
import { anyToDate } from 'mk/common/timeUtils';
import { Features } from 'mk2/apps/strollers/schemas';
import * as urls from 'mk2/apps/strollers/urls';
import Link from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import * as React from 'react';

// TBD: hardcoded 'sk-SK' for now

export const niceNumber = (value: number): string => {
    return value.toLocaleString('sk-SK');
};

export const niceSortInPlace = (arr: any[]): any[] => {
    const collator = new Intl.Collator('sk');
    return arr.sort(collator.compare);
};

export const terseDate = (dateThing: string | Date): string => {
    const date = anyToDate(dateThing);

    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
};

const DetailLink = ({ slug, visibleText }) => {
    return (
        <Link to={url(urls.strollersDetail, { slug })}>
            {visibleText}
        </Link>
    );
};

const BrandLink = ({ slug, visibleText }) => {
    return (
        <Link to={url(urls.strollersList, { slug })}>
            {visibleText}
        </Link>
    );
};

const LINK_RE = /(?:\s*([-\w]+)\s*:)?\s*(.+)/;

// link types:
// 'slug' -> stroller's detail
// 'brand:slug' -> brand's list

const lnkProcessor = (lnk, visibleText): React.ReactChild => {
    const match = LINK_RE.exec(lnk);
    if (!match) {
        return null;
    }
    if (match[1] && match[1].toLowerCase() === 'brand') {
        const slug = match[2];
        return (
            <BrandLink slug={slug} visibleText={visibleText} />
        );
    } else {
        return (
            <DetailLink slug={lnk} visibleText={visibleText} />
        );
    }
};

export const linkize = (text: string) => wpLinkize(text, lnkProcessor);

const SIBLING_TYPES = {
    'siblings': true,
    'siblings (double)': true,
    'siblings (tandem)': true,
    'siblings (triple)': true,
};

export const isSiblingType = (features: Features): boolean => {
    return features.type.some((type) => type in SIBLING_TYPES);
};
